import React,{ReactNode,useEffect,useState} from 'react';
import {Menus} from '../menu/menu'
import {List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {authSelector} from "../../store/auth/auth";
import {Huella1, Huella2} from "../../assets/image";
interface layoutComponent{
    children:ReactNode
}

export const LayoutAdmin =({children}:layoutComponent) =>{
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const navigate=useNavigate();
    const {user}=useSelector(authSelector);
    const arrayDirectSells = JSON.parse(
        process.env.REACT_APP_ID_VENTAS_DIRECTAS ?? ""
    );

    const [sidebarOpen, setSidebarOpen] = useState(false);

// Detectar si es móvil (opcional)
    const isMobile = window.innerWidth <= 768;
    const hasAccessToDirectSells = arrayDirectSells.some(
        (value:string) => +value === user.id
    );

    const hasAccessToUploadReport = [1, 45, 56].some(
        (value) => value === user.id
    );

    useEffect(() => {
        switch (window.location.pathname) {
            case '/reports-attendance':
                setSelectedIndex(0 );
                break;
            case '/reports':
                setSelectedIndex(1 );
                break;
        }
    }, []);

    return(
        <>
            <Menus/>
            {isMobile && (
                <button
                    className="menu-toggle"
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                >
                    ☰
                </button>
            )}
            <div className="cont-taxi-plan">
                <div className={`aside-panel ${sidebarOpen ? "open" : ""}`}>
                    <List component="nav" aria-label="main mailbox folders">
                        {
                            hasAccessToUploadReport &&    <ListItemButton
                                selected={selectedIndex === 0}
                                style={{marginTop:`${sidebarOpen ? "41px" : "0px"}`}}
                                onClick={(event) =>{
                                    setSelectedIndex(0);
                                    navigate("/reports-attendance", { replace: false })
                                }}

                            >
                                <ListItemIcon>
                                    <img src={Huella1}/>
                                </ListItemIcon>
                                <ListItemText primary="Carga del Reporte de Asistencia"/>
                            </ListItemButton>
                        }



                    </List>

                    <List component="nav" aria-label="main mailbox folders">

                        <ListItemButton
                            style={{marginBottom:'10px'}}
                            selected={selectedIndex === 1}
                            onClick={(event) =>{
                                setSelectedIndex(1);
                                navigate("/reports", { replace: false })
                            }}

                        >
                            <ListItemIcon>
                                <img src={Huella2}/>
                            </ListItemIcon>
                            <ListItemText primary="Reporte Personalizado"/>
                        </ListItemButton>


                    </List>

                </div>
                <main className="w-100">{children}</main>
            </div>
        </>
    )
}

export default LayoutAdmin;
